module.exports = __webpack_public_path__ + "static/img/product__time.4e688097.svg";